// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".GetDirectionLink-module-getDirectionLink-dFTdc{display:inline-flex;gap:10px;text-decoration:none}.GetDirectionLink-module-label-1vypw{text-wrap:nowrap}.GetDirectionLink-module-iconBlack-1olC_{color:#131110}.GetDirectionLink-module-iconBlue-2Dduh{color:#3567ff;color:var(--colors-accent-accent-100, #3567ff)}", ""]);
// Exports
exports.locals = {
	"getDirectionLink": "GetDirectionLink-module-getDirectionLink-dFTdc",
	"label": "GetDirectionLink-module-label-1vypw",
	"iconBlack": "GetDirectionLink-module-iconBlack-1olC_",
	"iconBlue": "GetDirectionLink-module-iconBlue-2Dduh"
};
module.exports = exports;
